/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="113.14"
        height="94.33"
        viewBox="0 0 113.14 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M50.1.01h-.45a7.8 7.8 0 0 0-7.78 7.78v.25a7.71 7.71 0 0 0 2.57 5.78L54 23.58a1.25 1.25 0 0 0 1.77 0l.93-.93 8.61-8.84a7.76 7.76 0 0 0 2.58-5.78v-.24A7.79 7.79 0 0 0 60.11 0h-.76a7.65 7.65 0 0 0-4.27 1.51l-.22.16-.21-.16A7.76 7.76 0 0 0 50.1.01Zm-.44 2.5h.44a5.3 5.3 0 0 1 3.74 1.55l.16.16a1.26 1.26 0 0 0 1.76 0l.16-.16a5.28 5.28 0 0 1 3.74-1.55h.45a5.28 5.28 0 0 1 5.28 5.28v.24a5.28 5.28 0 0 1-1.8 4l-8.73 8.9-8.73-8.92a5.28 5.28 0 0 1-1.8-4v-.24a5.29 5.29 0 0 1 5.33-5.26Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M18.48 83.79v10.55h-2.5V83.79h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M17.24 62.09a1.25 1.25 0 0 1 1.24 1.12V83.8a1.25 1.25 0 0 1-2.49.12V63.34a1.24 1.24 0 0 1 1.23-1.25ZM9.78 83.8v10.54h-2.5V83.8h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M8.53 42.35a1.28 1.28 0 0 1 1.25 1.16v40.32a1.25 1.25 0 0 1-2.49.12V43.6a1.25 1.25 0 0 1 1.24-1.25ZM17.23 6.96a9.19 9.19 0 1 0 9.19 9.19 9.18 9.18 0 0 0-9.18-9.18Zm0 2.5a6.69 6.69 0 1 1-6.68 6.7 6.67 6.67 0 0 1 6.68-6.63Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M25.43 83.8h1v10.54h-1V83.8z"/>
        <path
          fill="#0e497b"
          d="M27.18 83.8v10.54h-2.5V83.8h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M25.93 42.35a1.28 1.28 0 0 1 1.25 1.16v40.32a1.25 1.25 0 0 1-2.49.12V43.6a1.25 1.25 0 0 1 1.24-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M23.86 28.08a10.64 10.64 0 0 1 10.63 10.36v22.71a3.71 3.71 0 0 1-3.46 3.49h-5a1.25 1.25 0 0 1-.12-2.49h5a1.19 1.19 0 0 0 1.12-1.08V38.72a8.16 8.16 0 0 0-7.9-8.14H10.64a8.13 8.13 0 0 0-8.13 7.93v22.44a1.19 1.19 0 0 0 1.07 1.19h5a1.252 1.252 0 0 1 .13 2.5h-5A3.69 3.69 0 0 1 0 61.15V38.72a10.64 10.64 0 0 1 10.36-10.64ZM93.46 74.71v19.63h-2.5V74.71h2.5zM102.16 74.71v19.63h-2.5V74.71h2.5zM106.37 34.58a1.27 1.27 0 0 1 1.45.83v.13l5.19 23.59v.19a3.7 3.7 0 0 1-2.58 4.19h-.19l-4.73 1a1.25 1.25 0 0 1-.66-2.4h.13l4.72-1a1.19 1.19 0 0 0 .93-1.3v-.14l-5.2-23.58a1.25 1.25 0 0 1 .83-1.45ZM84.76 74.71v19.63h-2.5V74.71h2.5zM92.21 6.96a9.19 9.19 0 1 0 9.19 9.19 9.19 9.19 0 0 0-9.19-9.19Zm0 2.5a6.69 6.69 0 1 1-6.69 6.69 6.69 6.69 0 0 1 6.69-6.63Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M102.16 74.71v19.63h-2.5V74.71h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M100.63 42.38a1.25 1.25 0 0 1 1.46.83v.13l6.84 31.1a1.24 1.24 0 0 1-.94 1.48H76.68a1.25 1.25 0 0 1-1.25-1.25.76.76 0 0 1 0-.15v-.12l6.84-31.1a1.25 1.25 0 0 1 2.46.41v.12l-6.51 29.65h28l-6.51-29.59a1.24 1.24 0 0 1 .83-1.45Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M76.57 35.51a1.25 1.25 0 0 1 2.46.41v.12l-5.17 23.63a1.19 1.19 0 0 0 .79 1.39h.12l4.72 1a1.25 1.25 0 0 1-.41 2.46h-.12l-4.73-1a3.68 3.68 0 0 1-2.85-4.21v-.19Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M98.8 28.08a9.22 9.22 0 0 1 9.06 7.49 1.25 1.25 0 0 1-.9 1.52 1.23 1.23 0 0 1-1.52-.89.45.45 0 0 1 0-.16 6.74 6.74 0 0 0-6.36-5.46H85.62A6.73 6.73 0 0 0 79 36.04a1.25 1.25 0 1 1-2.48-.31.45.45 0 0 1 0-.16 9.22 9.22 0 0 1 8.79-7.49ZM52.86 76.29a1.27 1.27 0 0 1 1.25 1.13v14.76a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09v-14.8a1.25 1.25 0 0 1 1.24-1.22ZM46.35 62.41a1.25 1.25 0 0 1 1.24 1.1v28.64a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09V63.67a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M52.86 76.29a1.27 1.27 0 0 1 1.25 1.13v14.76a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09v-14.8a1.25 1.25 0 0 1 1.24-1.22ZM59.4 62.41a1.25 1.25 0 0 1 1.24 1.1v28.64a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09V63.67a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M52.86 76.29a1.27 1.27 0 0 1 1.25 1.13v14.76a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09v-14.8a1.25 1.25 0 0 1 1.24-1.22ZM47.6 65.83v28.51h-2.5V65.83h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M54.12 79.71v14.63h-2.5V79.71h2.5zM60.65 65.83v28.51h-2.5V65.83h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M59 53.41a7.25 7.25 0 0 1 7.25 7v12.26a1.25 1.25 0 0 1-1.13 1.24H59.4a1.25 1.25 0 0 1-.13-2.49h4.51V60.67a4.74 4.74 0 0 0-4.54-4.74H46.73A4.75 4.75 0 0 0 42 60.46v11h4.38a1.24 1.24 0 0 1 1.21 1.06v.15a1.25 1.25 0 0 1-1.12 1.24h-5.75a1.24 1.24 0 0 1-1.24-1.12V60.67a7.25 7.25 0 0 1 7-7.25ZM52.86 36.21a7.23 7.23 0 1 0 7.23 7.23 7.22 7.22 0 0 0-7.22-7.22Zm0 2.5a4.73 4.73 0 1 1-4.72 4.74 4.73 4.73 0 0 1 4.72-4.78Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'FamilyHeartIcon';

export default Icon;
